import * as R from 'ramda';
import { memo } from 'react';
import { useShallow } from 'zustand/react/shallow';
import MoneyRendererV3 from '../../../components/Money/MoneyRendererV3/MoneyRendererV3';
import useProductDetailsStore from '../../../stores/ProductDetails/productDetails.store';
import useSharedEntities from '../../shared-entities/hooks/useSharedEntities';
import ProductPricesRendererV3 from '../prices/ProductPricesRendererV3/ProductPricesRendererV3';
import {
  ProductDetailsContentPricesProps,
  ProductDetailsEntityType,
} from './types/productDetails.types';

const ProductDetailsContentPrices = ({
  productDetailsEntityType,
  prices,
}: ProductDetailsContentPricesProps) => {
  const { shouldDisableAllPrices, disableRetailPrice, disableWholesalePrice } = useSharedEntities(
    {},
  );

  const { productDetailsModalState } = useProductDetailsStore(
    useShallow((productDetailsState) => ({
      productDetailsModalState: productDetailsState.productDetailsModalState,
    })),
  );

  if (shouldDisableAllPrices) {
    return null;
  }

  const isUnavailable = R.isEmpty(prices);
  if (isUnavailable) {
    return null;
  }

  if (productDetailsEntityType === ProductDetailsEntityType.KIT) {
    return <MoneyRendererV3 size="large" value={prices[0].wholesalePrice} />;
  }

  return (
    <ProductPricesRendererV3
      prices={prices}
      retailPriceDisabled={disableRetailPrice || productDetailsModalState.disablePrice}
      wholesalePriceDisabled={disableWholesalePrice || productDetailsModalState.disablePrice}
    />
  );
};

export default memo(ProductDetailsContentPrices);
